import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { CheckCircle2, ArrowRight } from 'lucide-react';

export default function Membership() {
  return (
    <div className="bg-white" data-testid="membership-page">
      <section className="py-20 md:py-28 bg-slate-50">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl text-center">
          <span className="text-[#D42B3C] font-semibold text-sm tracking-wider uppercase mb-4 block">Membership</span>
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 mb-6">Join the Alliance</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Choose the membership tier that is right for you.
          </p>
        </div>
      </section>

      <section id="benefits" className="py-20 md:py-28 bg-white">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card className="border border-slate-200 shadow-lg">
              <CardHeader className="text-center pt-8 pb-4">
                <CardTitle className="font-heading text-xl">Individual Agent</CardTitle>
                <div className="mt-4">
                  <span className="text-4xl font-bold text-slate-900">$199</span>
                  <span className="text-slate-600">/year</span>
                </div>
              </CardHeader>
              <CardContent className="pb-8">
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    Member directory access
                  </li>
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    Networking events
                  </li>
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    Market insights
                  </li>
                </ul>
                <Link to="/register">
                  <Button className="w-full bg-[#3D4F7A] hover:bg-[#2A3755] text-white">Get Started</Button>
                </Link>
              </CardContent>
            </Card>

            <Card className="border-2 border-[#3D4F7A] shadow-xl relative">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D42B3C] text-white text-xs px-3 py-1 rounded-full">Most Popular</div>
              <CardHeader className="text-center pt-8 pb-4">
                <CardTitle className="font-heading text-xl">Brokerage</CardTitle>
                <div className="mt-4">
                  <span className="text-4xl font-bold text-slate-900">$999</span>
                  <span className="text-slate-600">/year</span>
                </div>
              </CardHeader>
              <CardContent className="pb-8">
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    All Individual benefits
                  </li>
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    Up to 25 agent accounts
                  </li>
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    Priority event access
                  </li>
                </ul>
                <Link to="/register">
                  <Button className="w-full bg-[#3D4F7A] hover:bg-[#2A3755] text-white">Get Started</Button>
                </Link>
              </CardContent>
            </Card>

            <Card className="border border-slate-200 shadow-lg">
              <CardHeader className="text-center pt-8 pb-4">
                <CardTitle className="font-heading text-xl">Team</CardTitle>
                <div className="mt-4">
                  <span className="text-4xl font-bold text-slate-900">$499</span>
                  <span className="text-slate-600">/year</span>
                </div>
              </CardHeader>
              <CardContent className="pb-8">
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    All Individual benefits
                  </li>
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    Up to 10 team members
                  </li>
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    Team collaboration tools
                  </li>
                </ul>
                <Link to="/register">
                  <Button className="w-full bg-[#3D4F7A] hover:bg-[#2A3755] text-white">Get Started</Button>
                </Link>
              </CardContent>
            </Card>

            <Card className="border border-slate-200 shadow-lg">
              <CardHeader className="text-center pt-8 pb-4">
                <CardTitle className="font-heading text-xl">Affiliate Partner</CardTitle>
                <div className="mt-4">
                  <span className="text-4xl font-bold text-slate-900">$599</span>
                  <span className="text-slate-600">/year</span>
                </div>
              </CardHeader>
              <CardContent className="pb-8">
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    Partner directory listing
                  </li>
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    Networking opportunities
                  </li>
                  <li className="flex items-start gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#3D4F7A] flex-shrink-0" />
                    Sponsorship options
                  </li>
                </ul>
                <Link to="/register">
                  <Button className="w-full bg-[#3D4F7A] hover:bg-[#2A3755] text-white">Get Started</Button>
                </Link>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-[#3D4F7A]">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl text-center">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-6">Ready to Get Started?</h2>
          <p className="text-lg text-slate-300 mb-10">Join thousands of real estate professionals already benefiting from AREA membership.</p>
          <Link to="/register">
            <Button size="lg" className="bg-white text-[#3D4F7A] hover:bg-slate-100 px-10 py-6 text-lg font-semibold" data-testid="cta-apply-btn">
              Apply for Membership
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
